import React, { useState, useEffect } from "react";
import { Box, TextField, Button, Typography, Alert } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import Logo from "../../assets/logoazul.png";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

export default function LoginForm({ onSwitch, onForgotPassword, passwordResetSuccess }) {

    const { login } = useAuth();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [showResetSuccess, setShowResetSuccess] = useState(!!passwordResetSuccess);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState("");

    useEffect(() => {
        if (passwordResetSuccess) {
            setShowResetSuccess(true);
        }
    }, [passwordResetSuccess]);

    function showError(message) {
        setDialogMessage(message);
        setDialogOpen(true);
    }

    async function handleSubmit(e) {
        e?.preventDefault();
        if (loading) return;

        setLoading(true);

        const res = await login(email, password);

        if (!res.ok) {
            setLoading(false);
            return showError("Email ou senha inválidos.");
        }

        const loggedUser = JSON.parse(localStorage.getItem("emmaUser"));

        if (loggedUser?.role === "admin") {
            window.location.href = "/admin";
        } else {
            window.location.href = "/";
        }
    }

    return (
        <Box component="form" onSubmit={handleSubmit}>
            <img src={Logo} alt="logo" style={{ width: 150, marginBottom: 20 }} />

            <Typography variant="h5" sx={{ fontWeight: 700, textAlign: "start" }}>
                Seja bem-vindo ao Emma
            </Typography>

            <Typography sx={{ mt: 1, mb: 3, opacity: 0.6, textAlign: "start" }}>
                Entre na sua conta
            </Typography>

            {showResetSuccess && (
                <Alert
                    severity="success"
                    sx={{ mb: 2, textAlign: "left", borderRadius: 2 }}
                    onClose={() => setShowResetSuccess(false)}
                >
                    Senha redefinida com sucesso. Faça login com sua nova senha.
                </Alert>
            )}

            <TextField
                fullWidth
                placeholder="Email"
                margin="normal"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                sx={{
                    "& .MuiInputBase-input::placeholder": { color: "#b5b5b5", opacity: 1 },
                }}
            />

            <TextField
                fullWidth
                type="password"
                placeholder="Senha"
                margin="normal"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                sx={{
                    "& .MuiInputBase-input::placeholder": { color: "#b5b5b5", opacity: 1 },
                }}
            />

            <Typography
                sx={{
                    mt: 1,
                    textAlign: "end",
                    fontSize: 13,
                    cursor: "pointer",
                    textDecoration: "underline",
                    opacity: 0.75,
                }}
                onClick={onForgotPassword}
            >
                Esqueci minha senha
            </Typography>

            <Button
                fullWidth
                type="submit"
                variant="contained"
                disabled={loading}
                sx={{
                    mt: 2,
                    py: 1.4,
                    fontSize: 16,
                    borderRadius: "12px",
                    background: "var(--azul)",
                    ":hover": { background: "var(--azul)" },
                    opacity: loading ? 0.7 : 1,
                }}
            >
                {loading ? "Entrando..." : "Entrar"}
            </Button>

            <Typography
                sx={{
                    mt: 3,
                    textAlign: "center",
                    fontSize: 14,
                    cursor: "pointer",
                    textDecoration: "underline",
                    opacity: 0.8,
                }}
                onClick={onSwitch}
            >
                Criar uma nova conta
            </Typography>


            <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 700 }}>
                    Atenção
                </DialogTitle>

                <DialogContent>
                    <Typography sx={{ mt: 1 }}>
                        {dialogMessage}
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => setDialogOpen(false)}
                        variant="contained"
                        sx={{
                            background: "var(--azul)",
                            ":hover": { background: "var(--azul)" },
                        }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
